import {
  tradeDateRange,
  balancingAreaAuthority,
  oasisSnapshotIndicator,
} from '@/components/Ciso/BaseStore/CisoConfigs';

export default {
  dockConfig: {
    alignment: 'LEFT',
    visible: false,
  },
  searchFilterConfig: {
    tradeDateRange,
    balancingAreaAuthority: { ...balancingAreaAuthority, required: true, includeAllOption: false },
    oasisSnapshotIndicator: { ...oasisSnapshotIndicator, required: true },
  },
  fields: [{
    caption: 'TRADING DATE',
    dataType: 'string',
    dataField: 'tradingDate',
    area: 'row',
    expanded: true,
  }, {
    caption: 'TRADING HOUR',
    dataType: 'string',
    dataField: 'tradingHour',
    area: 'column',
    expanded: true,
    // }, {
    //   caption: 'MARKET TYPE',
    //   dataType: 'string',
    //   dataField: 'marketType',
    //   area: 'row',
    //   expanded: true,
  }, {
    caption: 'BAA',
    dataType: 'string',
    dataField: 'baa',
    area: 'row',
    expanded: true,
  }, {
    caption: 'SNAPSHOT INDICATOR',
    dataType: 'string',
    dataField: 'snapshotIndicator',
    area: 'row',
    expanded: true,
  }, {
    caption: 'CURVE DIRECTION',
    dataType: 'string',
    dataField: 'curveDirection',
    area: 'row',
    expanded: true,
  }, {
    caption: 'TEST INDICATOR',
    dataType: 'string',
    dataField: 'testIndicator',
    area: 'row',
    expanded: true,
  }, {
    caption: 'DATA TYPE',
    dataField: 'dataType',
    area: 'row',
    expanded: true,
    sortingMethod(a, b) {
      return a.text.localeCompare(b.text);
    },
  }, {
    caption: 'VALUE',
    dataField: 'value',
    area: 'data',
    expanded: true,
  }],
  options: {
    exportExcel: true,
    filterRow: true,
    filterHeader: true,
  },
};